import { LoadingState } from "./Loading.types";

export const LoadingStateDefault: LoadingState = {
  loading: false,
  setLoading: () => null,
};
